import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-16-书签",
  "use": "icon-16-书签-usage",
  "viewBox": "0 0 10 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 10 16\" id=\"icon-16-书签\">\n<style type=\"text/css\">\n\t#icon-16-书签 .st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n</style>\n<g>\n\t<path class=\"st0\" d=\"M4,0h2c2.2,0,4,1.8,4,4v12l-5-4l-5,4V4C0,1.8,1.8,0,4,0z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol